import "./lib/dayjs";
import * as serviceWorker from "./serviceWorker";
import "./instrumentation";
// plugins styles from node_modules
// import "react-perfect-scrollbar/dist/css/styles.css";
// our styles
import "./index.css";
import "@fontsource/roboto";
import "@fontsource/roboto/100-italic.css";
import "@fontsource/roboto/300-italic.css";
import "@fontsource/roboto/400-italic.css";
import "@fontsource/roboto/500-italic.css";
import "@fontsource/roboto/700-italic.css";
import "@fontsource/roboto/900-italic.css";
import "@fontsource/roboto/100.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import "@fontsource/roboto/900.css";

import { Amplify } from "aws-amplify";
import { createRoot } from "react-dom/client";
import App from "./App";
import config from "./Config";
import { setupQueryBroadcast } from "./lib/queryBroadcast";
import { setupRefreshLeader } from "./lib/refreshLeader";

// plugins styles downloaded
// core styles

serviceWorker.register({});
export const configureAmplify = (): void => {
  // Amplify v6: auth config nests under `Auth.Cognito`; region is derived from
  // the user pool id and the auth flow type moves to the signIn() call. The
  // former `API` endpoint config is gone — presigned-S3 fetches use axios.
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.cognito.USER_POOL_ID,
        userPoolClientId: config.cognito.APP_CLIENT_ID,
      },
    },
  });
};

configureAmplify();
setupQueryBroadcast();
setupRefreshLeader();
const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);
